import { TemplateAuthorGroup, TemplateVisibility } from '@heidi/schema/ml-scribe';
import { type TemplateResponse } from '@heidi/templates/contracts';
import type { MessageDescriptor } from 'react-intl';
import { viewFormModalMessages } from './view-form-modal.messages';

/**
 * Pick copy-on-save toast from template scope, not raw `team_id`.
 * Org-scoped IA templates store an org/team id in `team_id` but are not team templates.
 */
export const getCopyToastMessage = (template: TemplateResponse): MessageDescriptor => {
  if (template.template_author_group === TemplateAuthorGroup.Heidi) {
    return template.template_visibility === TemplateVisibility.Team
      ? viewFormModalMessages.cannotEditTeamTemplate
      : viewFormModalMessages.cannotEditHeidiTemplate;
  }

  if (template.template_visibility === TemplateVisibility.Organization) {
    return viewFormModalMessages.cannotEditSharedTemplate;
  }

  if (template.template_visibility === TemplateVisibility.Team || template.team_id) {
    return viewFormModalMessages.cannotEditTeamTemplate;
  }

  return viewFormModalMessages.cannotEditProtectedTemplate;
};
